import { BlockList } from '@zillow/cms-blocks';
import React from 'react';

import { PostsTemplate } from '../../../components/PostsTemplate';
import TermHero from '../../../components/TermHero/TermHero';
import {
    buildPrimaryTermPage,
    type TermPageContentProps,
} from '../../../util/buildPrimaryTermPage';
import { Layout } from '../[[...slug]]';

const CategoryPageContent = ({
    term,
    initialPage,
    stickySidebarTop,
}: TermPageContentProps & { stickySidebarTop?: string }) => {
    return (
        <PostsTemplate
            posts={term.posts}
            initialPage={initialPage}
            stickySidebarTop={stickySidebarTop}
            hero={
                <TermHero
                    total={term.posts?.total}
                    description={term.description}
                    name={term.name}
                />
            }
            sidebar={
                term.sidebar ? (
                    <BlockList blocks={term.sidebar?.blocks || []} />
                ) : null
            }
            footer={term.footer}
            archiveCategory={term.id}
            baseLink={term.link}
        />
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryTermPage({
        basePath: '/news/category',
        site: 'NEWS',
        taxonomy: 'CATEGORY',
        LayoutComponent: Layout,
        ContentComponent: CategoryPageContent,
        menuPropName: 'submenu',
        hasStickyNav: true,
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
